import { html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { ExtBaseElement } from '../../core/ExtBaseElement';
import './ext-hello.css';

/**
 * Smoke test del kit.
 * Renderiza un saludo estilado con tokens --ui-*.
 *
 * Nota sobre Light DOM:
 * - No usamos `static styles = css\`...\`` porque Lit solo inyecta esos estilos
 *   dentro del Shadow DOM. En Light DOM no tienen efecto.
 * - Usamos un CSS file co-localizado (ext-hello.css) importado como side-effect,
 *   que Vite concatena al bundle ui-kit.css final.
 */
@customElement('ext-hello')
export class ExtHello extends ExtBaseElement {
  @property({ type: String }) name = 'mundo';

  render() {
    return html`<span>Hola, ${this.name}! (ext-hello)</span>`;
  }
}
